import api from './api';
import type { PageResponse, QuotationItem } from '../types';

export interface QuotationQuery {
  search?: string;
  productId?: string;
  sort?: string;
  page?: number;
  size?: number;
}

export const adminQuotationService = {
  getAdminQuotations: async ({ search, productId, sort, page, size }: QuotationQuery = {}): Promise<PageResponse<QuotationItem>> => {
    const searchParams: Record<string, string | number> = {};
    if (search) searchParams.search = search;
    if (productId) searchParams.productId = productId;
    if (sort) searchParams.sort = sort;
    if (page !== undefined) searchParams.page = page;
    if (size !== undefined) searchParams.size = size;
    return api.get('quotations/admin', { searchParams }).json<PageResponse<QuotationItem>>();
  },
  deleteQuotation: async (quotationId: string): Promise<void> => {
    await api.delete(`quotations/${quotationId}`);
  },
};
